export const APP_ID = 'software.reports.burnup';

export const SPRINT_STATE_ACTIVE = 'ACTIVE' as const;
export const SPRINT_STATE_FUTURE = 'FUTURE' as const;
export const SPRINT_STATE_CLOSED = 'CLOSED' as const;

export const ISSUE_ADDED = 'ISSUE_ADDED' as const;
export const ISSUE_REMOVED = 'ISSUE_REMOVED' as const;
export const ESTIMATION_CHANGE = 'ESTIMATION_CHANGE' as const;
export const TRANSITION_TO_DONE = 'TRANSITION_TO_DONE' as const;
export const TRANSITION_TO_NOT_DONE = 'TRANSITION_TO_NOT_DONE' as const;
export const COLUMN_CHANGE = 'COLUMN_CHANGE' as const;
export const UNKNOWN_EVENT = 'UNKNOWN_EVENT' as const;
export const START_EVENT = 'START_EVENT' as const;
export const END_EVENT = 'END_EVENT' as const;

export const COMPLETION_SCATTER_SERIES = 'COMPLETION_SCATTER_SERIES' as const;
export const SCOPE_SCATTER_SERIES = 'SCOPE_SCATTER_SERIES' as const;

export const WORKING = 'WORKING' as const;
export const NON_WORKING = 'NON_WORKING' as const;

export const COLORS = {
	PURPLE: 'PURPLE',
	BLUE: 'BLUE',
	GREEN: 'GREEN',
	TEAL: 'TEAL',
	YELLOW: 'YELLOW',
	ORANGE: 'ORANGE',
} as const;

/** default maps to inprogress we want all that can't be defined below to be blue to match bento.
    The new ones require to be grey so should be using default status.
*/
export const STATUSES = {
	default: 'inprogress',
	inprogress: 'inprogress',
	moved: 'moved',
	new: 'default',
	removed: 'removed',
	success: 'success',
	done: 'success',
} as const;
